'use client';

import { motion } from 'framer-motion';
import React from 'react';
import Projects from './projects';

export default function ProjectsClient() {
  return (
    <main>
      <div className="relative container mx-auto px-4 pt-40 md:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-16 text-center"
        >
          <div className="from-foreground via-primary to-foreground mb-4 bg-gradient-to-r bg-clip-text text-4xl leading-tight font-bold text-transparent md:text-5xl lg:text-6xl xl:text-7xl">
            <span className="text-foreground">Selected </span> Projects
          </div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-muted-foreground antonio mx-auto max-w-2xl font-serif text-xl leading-relaxed sm:text-2xl md:max-w-3xl"
          >
            Projects that showcase technical expertise and real-world impact
          </motion.p>
        </motion.div>
      </div>
      <section className="px-6 py-16 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <Projects />
        </motion.div>
      </section>
    </main>
  );
}
